import React, {
  useState,
  // useRef,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import ImageCards from "@/components/ImageCards";
import { Footer, Header, useConfirm } from "@/components";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import styles from "./ReelsUpsert.module.css";
import "@/App.css";
import { ko } from "date-fns/locale"; // 한국어 로케일을 가져옵니다.
import { format } from "date-fns";
import Axios from "@/Axios";
import { useNavigate, useParams } from "react-router-dom";
import { INSERT_TAG } from "@pages";
import { decoded } from "@/utils";
import {
  useLoadReset,
  useDebouncedCallback,
  useDimLoading,
  useDimLoadComplete,
} from "@/hooks";

const DATE_ONLY = "yyyy-MM-dd";
const DATE_TIME = "yyyy-MM-dd HH:mm:ss";

export default function ReelsUpsert() {
  const dimLoading = useDimLoading();
  const dimLoadComplete = useDimLoadComplete();
  const loadReset = useLoadReset();
  const { tag, info } = useParams();
  const confirm = useConfirm();
  const navigate = useNavigate();
  const defaultDate = null;
  const [startDate, setStartDate] = useState(defaultDate);
  const [startEndDate, setStartEndDate] = useState(defaultDate);
  const defaultState = {
    checkedFilter: false,
    reelsNm: "",
    id: "",
    instaRegDate: "",
    image: "",
    headerTitle: "릴스 등록",
    buttonNm: "등록",
    isInsert: true,
    link: "",
    mediaId: "",
    list: [],
    reelsCategoryID: "",
    mediaId: "",
    title: "",
    checkedAscFilter: false,
    clickedCount: 0,
  };
  const [state, setState] = useState(defaultState);
  const searchInstaMediaList = () => {
    Axios.get("/api/reels/insta-media/list", {
      params: {
        checkedFilter: state.checkedFilter,
        regDateFilter: startDate ? format(startDate, DATE_ONLY) : null,
        checkedAscFilter: state.checkedAscFilter,
        endDateFilter: startEndDate ? format(startEndDate, DATE_ONLY) : null,
      },
    }).then((res) => {
      if (res.data?.errMsg) {
        confirm(`${res.data.errMsg}\n(${res.data.errCode})`);
        return;
      }
      if (!res.data?.instaMediaList) {
        setState((s) => ({
          ...s,
          list: [],
          mediaId: "",
          instaRegDate: "",
          image: "",
          link: "",
          caption: "",
        }));
      }
      const list = res.data?.instaMediaList?.map((data) => ({
        id: data.id,
        image: data.thumbnail_url,
        instaRegDate: format(data.timestamp, DATE_TIME),
        link: data.media_url,
        caption: data.caption,
      }));
      if (list?.length > 0) {
        setState((s) => ({ ...s, list }));
      }
    });
  };
  const changeDate = (date) => {
    setStartDate(date);
    if (date > startEndDate) {
      setStartEndDate(defaultDate);
    }
  };
  const changeEndDate = (date) => {
    setStartEndDate(date);
  };
  const onOffFilter = () => {
    setState((s) => ({ ...s, checkedFilter: !s.checkedFilter }));
  };
  const onAscFilter = () => {
    setState((s) => ({
      ...s,
      checkedAscFilter: !s.checkedAscFilter,
    }));
  };
  const changeReelsName = (e) => {
    setState((s) => ({ ...s, reelsNm: e.target.value }));
  };
  const setCard = useCallback((card) => {
    setState((s) => ({
      ...s,
      mediaId: card.id,
      instaRegDate: card.instaRegDate,
      image: card.image,
      link: card.link,
      caption: card.caption,
    }));
  }, []);

  const insert = useDebouncedCallback(() => {
    dimLoading();
    Axios.post("/api/reels/insert", state).then((res) => {
      if (res.data?.errMsg) {
        dimLoadComplete(() => {
          confirm(`${res.data.errMsg}\n(${res.data.errCode})`);
        });
        return;
      }
      dimLoadComplete(() => {
        confirm(
          `등록이 완료되었습니다.\n확인을 누르면 목록으로 이동합니다.`,
          () => {
            navigate(`/reels-list/${state.reelsCategoryID}/${state.title}`, {
              replace: true,
            });
          }
        );
      });
    });
  });

  const update = useDebouncedCallback(() => {
    dimLoading();
    Axios.post("/api/reels/update", {
      ...state,
      index: state.id,
    }).then((res) => {
      if (res.data?.errMsg) {
        dimLoadComplete(() => {
          confirm(`${res.data.errMsg}\n(${res.data.errCode})`);
        });
        return;
      }
      dimLoadComplete(() => {
        confirm(
          `수정이 완료되었습니다.\n확인을 누르면 목록으로 이동합니다.`,
          () => {
            navigate(`/reels-list/${state.reelsCategoryID}/${state.title}`, {
              replace: true,
            });
          }
        );
      });
    });
  });
  const resetState = () => {
    setState(defaultState);
    loadReset();
  };

  const reelsList = useMemo(() => {
    return [...state.list];
  }, [state.list]);

  const clearValue = () => {
    setStartDate(defaultDate);
    setStartEndDate(defaultDate);
  };

  const activeSearch = () => {
    setState((s) => ({ ...s, clickedCount: ++s.clickedCount }));
  };

  useEffect(() => {
    const data = decoded(info, true);
    if (tag === INSERT_TAG) {
      setState((s) => ({
        ...s,
        reelsCategoryID: data.reelsCategoryId,
        title: data.title,
      }));
      return resetState;
    }
    setState((s) => ({
      ...s,
      reelsNm: data.reelsNm,
      headerTitle: "릴스 수정",
      buttonNm: "수정",
      isInsert: false,
      id: data.id,
      reelsCategoryID: data.reelsCategoryId,
      title: data.title,
      list: [
        {
          mediaId: data.mediaId,
          instaRegDate: data.instaRegDate,
          image: data.image,
          link: data.link,
          caption: data.caption,
        },
      ],
    }));
    return resetState;
  }, []);

  useEffect(() => {
    if (tag === INSERT_TAG) {
      searchInstaMediaList();
      return;
    }
  }, [state.checkedFilter, state.checkedAscFilter, state.clickedCount]);
  return (
    <div className={styles.mainContainer}>
      <div className={styles.container}>
        <Header title={state.headerTitle} isShare={false} />
        {state.isInsert && (
          <div className={styles.dateAndSearchContainer}>
            <div className={styles.datePickerContainer}>
              <DatePicker
                selectsStart
                selected={startDate}
                onChange={changeDate}
                dateFormat={DATE_ONLY}
                locale={ko}
                showPopperArrow={false}
                className="custom-input"
                placeholderText="등록일"
                popperClassName="custom-popper-start"
              />
              <label className={styles.dateLabel}> ~ </label>
              <DatePicker
                selectsEnd
                selected={startEndDate}
                onChange={changeEndDate}
                dateFormat={DATE_ONLY}
                locale={ko}
                showPopperArrow={false}
                className="custom-input"
                minDate={startDate}
                placeholderText="기간 설정"
                popperClassName="custom-popper-end"
              />
              {(startDate || startEndDate) && (
                <div
                  className={styles.cancel}
                  onClick={(e) => {
                    clearValue(e);
                  }}
                >
                  X
                </div>
              )}
              <div className={styles.searchButtonArea}>
                <button
                  className={styles.registerButton}
                  onClick={activeSearch}
                >
                  <span className={styles.register}>검색</span>
                </button>
              </div>
            </div>

            <span
              className={styles.hideDuplicates}
              style={{ paddingLeft: "16px" }}
            >
              등록일 기준으로 검색을 진행합니다
            </span>
          </div>
        )}
        {state.isInsert && (
          <>
            <div className={styles.filterArea}>
              <div className={styles.filterDescription}>
                <div className={styles.mainDescription}>
                  <span className={styles.excludeList}>
                    이미 등록된 릴스를 제외합니다
                  </span>
                </div>
                <div className={styles.additionalDescription}>
                  <span className={styles.hideDuplicates}>
                    중복 등록 방지를 위해 릴스 목록에서 숨김 처리합니다
                  </span>
                </div>
              </div>
              <div className={styles.checkboxArea} onClick={onOffFilter}>
                <div className={styles.checkbox}>
                  {state.checkedFilter && (
                    <div className={styles.checkedIcon} />
                  )}
                </div>
              </div>
            </div>
            <div className={styles.filterArea}>
              <div className={styles.filterDescription}>
                <div className={styles.mainDescription}>
                  <span className={styles.excludeList}>
                    오래된 순서대로 보여줍니다
                  </span>
                </div>
                <div className={styles.additionalDescription}>
                  <span className={styles.hideDuplicates}>
                    과거에서 미래로 정렬합니다
                  </span>
                </div>
              </div>
              <div className={styles.checkboxArea} onClick={onAscFilter}>
                <div className={styles.checkbox}>
                  {state.checkedAscFilter && (
                    <div className={styles.checkedIcon} />
                  )}
                </div>
              </div>
            </div>
          </>
        )}
        {!state.isInsert && (
          <div className={styles.reelsNm}>
            <div className={styles.starIcon} />
            <div className={styles.reelsInput}>
              <input
                className={styles.reelsInputInput}
                placeholder="릴스명을 입력해주세요"
                defaultValue={state.reelsNm}
                onKeyUp={changeReelsName}
              />
            </div>
          </div>
        )}
        {state.list.length > 0 ? (
          <ImageCards
            list={reelsList}
            setCard={setCard}
            containerStyle={state.isInsert ? {} : { maxHeight: "48vh" }}
          />
        ) : (
          <div
            className={styles.listArea}
            style={{ maxHeight: "35vh", fontWeight: "bold" }}
          >
            <p>릴스가 존재하지 않습니다</p>
          </div>
        )}
        {state.isInsert && (
          <div className={styles.reelsNm}>
            <div className={styles.starIcon} />
            <div className={styles.reelsInput}>
              <input
                className={styles.reelsInputInput}
                placeholder="릴스명을 입력해주세요"
                defaultValue={state.reelsNm}
                onKeyUp={changeReelsName}
              />
            </div>
          </div>
        )}
        <div className={styles.divRegisterArea}>
          <button
            className={styles.buttonRegister}
            onClick={state.isInsert ? insert : update}
          >
            <span className={styles.spanRegister}>{state.buttonNm}</span>
          </button>
        </div>
        <Footer />
      </div>
    </div>
  );
}
